/**
 * Component bottom navigation chính của ứng dụng
 * 
 * HINTS:
 * - Có thể thêm haptic feedback khi tap
 * - Có thể thêm tooltip cho mỗi tab
 * - Có thể thêm right-click context menu
 * - Có thể thêm keyboard shortcuts
 */

import React, { useEffect, useState } from 'react'
import { BottomNavigationProps } from './types'
import { NavItem } from './navigation/NavItem'
import styles from './navigation/styles.module.css'

export const BottomNavigation: React.FC<BottomNavigationProps> = ({
  shouldHideUI,
  location,
  menuItems
}) => {
  if (shouldHideUI) return null;
  return (
    <nav className={`${styles.nav} bottom-navigation`}>
      <div className={styles.navContainer}>
        {menuItems.map((item) => {
          const isActive = item.path === '/workspace'
            ? location.pathname === '/' || location.pathname === '/workspace'
            : location.pathname.startsWith(item.path)

          return (
            <NavItem
              key={item.path}
              {...item}
              isActive={isActive}
            />
          )
        })}
      </div>
    </nav>
  )
} 